'use strict';

var chunkNCQUVFG7_js = require('./chunk-NCQUVFG7.js');
var chunkWAUX3N2G_js = require('./chunk-WAUX3N2G.js');
var chunk32OAM7MJ_js = require('./chunk-32OAM7MJ.js');
var jsxRuntime = require('react/jsx-runtime');

var l=({type:m,referenceSize:e,className:s,...a})=>{let o=m?.slice(0,3)?.toLocaleLowerCase(),t=chunkNCQUVFG7_js.a([e,e,e],[24,24,24]),i={"--mobile-offset":t[0],"--tablet-offset":t[1],"--desktop-offset":t[2]};return jsxRuntime.jsx("span",{className:chunkWAUX3N2G_js.a(`${chunk32OAM7MJ_js.a}-document-type ${o} ${s||""}`),style:i,...a,children:o.toUpperCase()})},c=l;

exports.a = c;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-2SN4MRXK.js.map